;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var View = APP.module('View');

	View.LeaguesRegenerationInvites =  Marionette.ItemView.extend({
		template: JST.LeaguesRegenerationInvites,
		data: {},
		ui: {
			send_invites:    	'#send_invites',
			send_all_invites: 	'#send_all_invites',
			remove_contact: 	'.js-remove-contact',
			skip_step: 			'.js-skip-step'
		},
		events: {
			'click @ui.remove_contact':    'removeContact',
			'click @ui.send_invites':  'sendInvites',
			'click @ui.send_all_invites':  'sendAllInvites',
			'click @ui.skip_step' : 'invitesSent'
		},
		initialize : function(){
			this.scrollToTop();
			this.league_id    	= this.getOption('league_id');
			//this.invites_id 	= this.getOption('invites_id');
			this.league        	= this.getOption('league');
			this.invites       	= this.getOption('invites') ? this.getOption('invites').users : [];
			this.user          	= this.getOption('user');
			this.getting_data  	= false;

			this.listenTo(this.league, 'leagues:errors', this.showErrors);
			this.listenTo(this.league, 'leagues:invite:success', this.invitesSent);

			var complete = [
				this.league.show().fetch({ data:{ id: this.league_id } })
				//this.invites.fetchFromLeague(this.invites_id)
			];

			$.when.apply(null, complete).done(_.bind(this.initData, this));
		},
		initData: function() {
			//this.trigger('leagues:manage:menu', this.league);
			this.setTemplateData({
				league:  this.league.toJSON(),
				invites: this.invites,
				show_data: this.invites.length > 0,
				show_contacts: this.invites.length > 0 && this.invites.length < 20

			});

			return this;
		},
		setTemplateData: function(obj) {
			_.extend(this.data, obj);
			this.getting_data = true;
			this.render();

			return this;
		},
		render: function() {
			if (!this.getting_data) {
				return this;
			}
			this.$el.html(this.template(this.data));

			return this;
		},
		removeContact: function(e){
			e.preventDefault();
			var email = $(e.currentTarget).data('email'),
				contactsIdx = this.invites.indexOf(_.findWhere(this.invites, {'email':email}));
			this.invites.splice(contactsIdx,1);
			this.initData();
		},
		sendInvites: function(e) {
			e.preventDefault();
			var invites = this.invites;

			invites = _.filter(invites, function(invite) { return invite.first_name.length && invite.email.length; });
			if (invites.length) {
				this.showPreloader();
				this.league.invite(invites);
			}

			return this;
		},
		sendAllInvites: function(e){
			e.preventDefault();
			this.showPreloader();
			this.league.regenerateInvite(this.league_id, this.invites_id);
		},
		invitesSent: function() {
			var league_id = this.invites_id,
				regenerated_league_id = this.league_id;
			this.hidePreloader();
			// APP.vent.trigger('popup:message:show', 'Your invites have been sent!');
			this.trigger('leagues_invites:success', league_id, regenerated_league_id);
			return this;
		}

	});

}(window, APP, Backbone, Marionette, $, _));